import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
	name: 'auth/session',
	initialState: {
        token: '',
        signedIn: false,
        permissions: [],
        navigation: []
    },
	reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            // Was action.payload.data1.id -- that's the USER ID (ResponseModel's
            // Data1 field), not the JWT. The real signed token is in
            // action.payload.token (ResponseModel's Token field, from
            // AccountRepository.GenerateJWTToken). This meant every request that
            // reads this slice for its bearer token (BaseService's request
            // interceptor) was sending "Authorization: Bearer <user id>" instead
            // of a real token -- guaranteed to fail validation and, once the
            // PC_API security fix started enforcing auth, trigger this slice's
            // own onSignOutSuccess() via BaseService's 401 response interceptor.
            state.token = action.payload.token
            state.navigation = action.payload.data
            state.permissions = action.payload.data2

        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
            state.permissions = []
            state.navigation = []
        },
        setToken: (state, action) =>  {
            state.token = action.payload
        }
	},
})

export const { onSignInSuccess, onSignOutSuccess, setToken } = sessionSlice.actions

export default sessionSlice.reducer